import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/v4ward/park/coupon/issue/page/v2', Object.assign({}, options, {
    params
  }));

export const getDetail = (params, options) =>
  request.get('/api/v4ward/park/coupon/giveout/detail/v2', Object.assign({}, options, {
    params
  }));

export const remove = (params, options) =>
  request.post('/api/v4ward/park/coupon/giveout/remove/v2', qs.stringify(params), options);

export const cancel = (params, options) =>
  request.post('/api/v4ward/park/coupon/giveout/cancel/v2', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/v4ward/park/coupon/giveout/save/v2', params, options);



export const syncCouponGiveOut = (params, options) =>
  request.post('/api/v4ward/park/coupon/giveout/sync/v2', qs.stringify(params), options);


// 商家下拉框
export const shopSelections = (params, options) =>
  request.get('/api/v4ward/park/coupon/shop/shopSelections/v2', Object.assign({}, options, {
    params
  }));

//  优惠劵下拉框
export const getCouponShopRecordList = (params, options) =>
  request.get('/api/v4ward/park/coupon/shop/record/getCouponShopRecordList/v2', Object.assign({}, options, {
    params
  }));

//  新增
export const save = (params, options) =>
  request.post('/api/v4ward/park/coupon/issue/save/v2', params, options);
//  编辑
export const update = (params, options) =>
  request.post('/api/v4ward/park/coupon/issue/update/v2', params, options);
//  编辑
export const sendCouponsToCar = (params, options) =>
  request.post('/api/v4ward/park/coupon/issue/sendCouponsToCar/v2', params, options);



// 统计已使用商家优惠券
export const getCouponReceiveNumSumByShopId = (params, options) =>
  request.get('/api/v4ward/park/coupon/issue/getCouponReceiveNumSumByShopId/v2', Object.assign({}, options, {
    params
  }));


// 统计商家优惠券总数
export const getCouponSumByShopId = (params, options) =>
  request.get('/api/v4ward/park/coupon/shop/record/getCouponSumByShopId/v2', Object.assign({}, options, {
    params
  }));

// 统计商家优惠券总数
export const getCouponNumByShopId = (params, options) =>
  request.get('/api/v4ward/park/coupon/issue/getCouponNumByShopId/v2', Object.assign({}, options, {
    params
  }));
